import './Report.scss';

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { loadReportSnapshot } from 'actions/reports';
import Button from 'atoms/button';
import { DateRangeInput } from 'atoms/date-range-input';
import GroomersDropdown from 'organisms/GroomersDropdown';

const DEFAULT_START_DATE = dayjs().subtract(6, 'day');
const DEFAULT_END_DATE = dayjs();

export default function Report() {
  const dispatch = useDispatch();
  const { snapshot } = useSelector((state) => state.reports);
  const { selectedGroomer } = useSelector((state) => state.ui);
  const [dateRange, setDateRange] = useState([
    DEFAULT_START_DATE,
    DEFAULT_END_DATE,
  ]);
  const [startDate, endDate] = dateRange;

  const { totalAppointments, totalClients, totalRevenue } = snapshot;

  useEffect(() => {
    if (startDate && endDate) {
      dispatch(loadReportSnapshot({ range: dateRange }));
    }
  }, [dateRange, selectedGroomer]);

  const onDateRangeChange = (range) => {
    const [start, end] = range;
    setDateRange([start, end]);
  };

  return (
    <>
      <Helmet title="Report | PawCare" />
      <div className="w-100 flex-row report h-100">
        <div className="page-container report-page-container">
          <div className="flex-row justify-between report-page-container-header pb-20 pt-20 prl-40 border-bottom-light-purple">
            <div className="flex-row gap-16">
              <h1>Overview</h1>
              <p className="f24 c-secondary-purple">
                {startDate ? dayjs(startDate).format('MMM D, YYYY') : ''}
                {startDate && endDate ? ' - ' : ''}
                {endDate ? dayjs(endDate).format('MMM D, YYYY') : ''}
              </p>
            </div>
            <div className="flex-row gap-12">
              <DateRangeInput
                onChange={onDateRangeChange}
                dateRanges={dateRange}
              />
              <GroomersDropdown />
            </div>
          </div>

          <div className="report-page-container-snapshot-section pt-32 prl-40 flex-column gap-12">
            <h2 className="f20">Your snapshot</h2>
            <div className="report-page-container-snapshot-container flex-row gap-16">
              <div className="snapshot flex-column p-24 w-100 mw-33 border-light-purple radius-16">
                <p className="f56 bold lh-64">{totalRevenue || '-'}</p>
                <p className="f13 c-primary-purple uppercase">Total Revenue</p>
              </div>
              <div className="snapshot flex-column p-24 w-100 mw-33 border-light-purple radius-16">
                <p className="f56 bold lh-64">{totalAppointments || '-'}</p>
                <p className="f13 c-primary-purple uppercase">
                  Total Appointments
                </p>
              </div>
              <div className="snapshot flex-column p-24 w-100 mw-33 border-light-purple radius-16">
                <p className="f56 bold lh-64">{totalClients || '-'}</p>
                <p className="f13 c-primary-purple uppercase">Total Clients</p>
              </div>
            </div>
          </div>

          {/* <div className="report-page-container-table-container pt-32 prl-40 flex-column gap-12">
            <div className="flex-row justify-between">
              <h2 className="f20">Payroll report</h2>
              <Button
                variant="link"
                size="medium-small"
                onClick={() => {}}
                text="View all"
              />
            </div>
            <p>Table</p>
          </div> */}
        </div>
      </div>
    </>
  );
}
